import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { SafeHtml } from '@angular/platform-browser';

export interface RowItem {
  question: string;
  answer: SafeHtml;
  isOpen?: boolean;
}

@Component({
  selector: 'app-text-accordion',
  templateUrl: './text-accordion.component.html',
  styleUrls: ['./text-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatExpansionModule],
})
export class TextAccordionComponent {
  @Input({ required: true }) rows: RowItem[] = [];
}
